import { Component, OnInit, AfterContentChecked, Input, Output, OnDestroy } from '@angular/core';
import { Settings, AppSettings } from '../../../app.settings';
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { NavigationEnd, Router } from '@angular/router';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { SidenavMenuService } from '../sidenav-menu/sidenav-menu.service';
import { EventEmitter } from '@angular/core';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { ActivatedRoute} from '@angular/router'
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-account-side-menu',
  templateUrl: './account-side-menu.component.html',
  styleUrls: ['./account-side-menu.component.scss']
})
export class AccountSideMenuComponent implements OnInit, OnDestroy {
  public loggedIn = false;
  public currencies = ['USD', 'EUR'];
  public currency: any;
  public userDetails: any;
  // @Input('menuItems') menuItems: [];
  @Input('menuItems') menuItems: any[] = [];
  @Input('menuParentId') menuParentId;
  @Output() emitPass: EventEmitter<any> = new EventEmitter()
  loginSubService;
  public flag: any;
  storeDetails = {};
  featureTags = {};
  public settings: Settings;
  private destroy$ = new Subject<void>();
  
  constructor(
    private sidenavMenuService: SidenavMenuService,
    public router: Router,
    public appSettings: AppSettings,
    public apiService: ApiService,
    private notification: NotificationService,
    private subscription: SubscriptionService,
    public sharedDataService: SharedDataService,
    private route: ActivatedRoute,

  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    /******* login action completed after get user details in top menu********/
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    this.loginSubService = this.apiService.getLogin().subscribe(data => {
      this.loggedIn = data.loggedIn;
      this.userDetails = data.userDetails;
    }, err => { });
    /******* end********/
    /******* page refreshed after get user details in top menu********/
    this.loggedIn = this.apiService.loggedIn();
    this.apiService.getAutheticatedUserDetails().subscribe(data => {
      if (data['response']['status'] === 1) {
        this.userDetails = data['response']['data']['users'];
        if(!!this.featureTags && this.featureTags['sf_enhance_registration_membership']){
         this.apiService.setLogin({
            loggedIn: true,
            userDetails: this.userDetails,
        });
      }
        // Set Delivery Address Details for Delivery Calendar
        this.subscription.setUserAddressDetails(this.userDetails);
      }
    }, err => { })
    if(!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']){
    this.matchLinkWithUrl(this.router.url);
    // Handle URL changes (navigations)
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(event => this.matchLinkWithUrl(event.url));
    }
    
    /******* end********/
    if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
          this.storeDetails = this.route.snapshot.data['store']['response']['data']['store'];
    }
  }
  private matchLinkWithUrl(url: string): void {
    const currentUrl = url.replace(/^\//, ''); // Remove leading slash
    const myAccount = this.menuItems.find(item => item.title?.name === 'My Account');
    const matchingLink = myAccount?.links?.find(link => link.href === currentUrl);
    this.sharedDataService.emitPassEvent(matchingLink);
  }
  ngOnDestroy() {
    !!this.loginSubService && !!this.loginSubService.unsubscribe();
  }
  public logout() {
    this.apiService.logout().subscribe(data => {
      if (data['response']['status'] === 1) {
        localStorage.clear();
        // sessionStorage.clear();
        this.apiService.setLogin({
          loggedIn: false,
          userDetails: null
        });
        this.subscription.subjectNext({ msg: 'logged out' })
        this.sharedDataService.cartDataSource.next(false);
        var queryParams = this.router.url.includes('cart') ? { queryParams: { 'redirectURL': this.router.url } } : {};
        if (!!this.featureTags && this.featureTags['ftags_membership']) {
          sessionStorage.removeItem('membership_item');
        }
        this.router.navigate(['/sign-in'], queryParams);
        this.notification.success(data['response']['message'], 5000);
      } else {
        this.notification.error(data['response']['message'], 5000);
      }
    }, err => { console.log('get user details error', err) })
  }

  handleChange(event) { 
    if (event['href'] && event['href'] === 'sign-in') {
      var queryParams = this.router.url.includes('cart') ? { queryParams: { 'redirectURL': this.router.url } } : {};
      this.router.navigate(['/sign-in'], queryParams);
    } else if (event['name'] && event['name'] === 'Logout') {
      this.apiService.logout().subscribe(data => {
        if (data['response']['status'] === 1) {
          let storeData = sessionStorage.getItem('store');
          // sessionStorage.clear();
          localStorage.clear();
          this.apiService.setLogin({
            loggedIn: false,
            userDetails: null
          });
          if (!!this.featureTags && this.featureTags['ftag_allow_product_to_customer_based_events']) {
            sessionStorage.removeItem('user_event_ids');
          }
          sessionStorage.setItem('store', storeData);
          this.sharedDataService.cartDataSource.next(false);
          this.subscription.subjectNext({ msg: 'logged out' });
          var queryParams = this.router.url.includes('cart') ? { queryParams: { 'redirectURL': this.router.url } } : {};
          this.router.navigate(['/sign-in'], queryParams);
          this.notification.success(data['response']['message'], 5000);
        } else {
          this.notification.error(data['response']['message'], 5000);
        }
      }, err => { console.log('get user details error', err) })
    } else {
      if(!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']){
        this.sharedDataService.emitPassEvent(event);
      }
      this.emitPass.emit(event);
    }
  }
}
